export default {
    UPLOAD_SALES_DATA: "UPLOAD_SALES_DATA",
    PULL_DATA_FROM_DI_CLICKED: "PULL_DATA_FROM_DI_CLICKED"
};
